import React from "react";
import "./styles.css";

const NPS_OPTIONS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
const INPUT_LABEL =
  "On a scale from 0-10, how likely are you to recommend it to a friend or colleague? (*)";

export default class NPSInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: null,
    };
  }

  handleSelect(value) {
    this.setState({ selected: value });
    this.props.handleSelected(value);
  }

  renderOptions() {
    return NPS_OPTIONS.map((number) => {
      return (
        <li
          className={this.state.selected === number ? "nps-selected" : "nps-item"}
          onClick={() => this.handleSelect(number)}
        >
          {number}
        </li>
      );
    });
  }

  render() {
    return (
      <div className="nps-wrapper">
        <span>{INPUT_LABEL}</span>
        <ul className="nps-list">{this.renderOptions()}</ul>
        <div className="nps-info">
          <span>
            Not likely at all
          </span>
          <span>
            Extremely likely
          </span>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/NPSInput/NPSInput.jsx